<script>
    import {Doughnut, mixins} from 'vue-chartjs';

    export default {
        name   : "StatCardsByTypeDoughnutChart",
        extends: Doughnut,
        mixins : [mixins.reactiveProp],
        props  : {
            chartData: {
                type   : Object,
                default: null
            },
        },
        data() {
            return {
                options: {
                    responsive         : false,
                    maintainAspectRatio: true,
                    legend             : {
                        display: false,
                    },
                }
            }
        },
        mounted() {
            this.renderChart(
                this.chartData,
                this.options,
            );
        }
    }
</script>

<style scoped>
    canvas {
        margin: auto;
    }
</style>
